module.exports = __webpack_public_path__ + "static/media/sch-5.5ea43f57.jpg";